module.exports = __webpack_public_path__ + "staticfr/media/paredocientec.375b21e9.mp4";